import { memo, useCallback, useMemo } from 'react';
import PlayerTimelineButton from './PlayerTimelineButton';
import { useTranscriptContext } from '@/context/TranscriptContext/TranscriptContext';
import { FPS_24 } from '@/App/remotion/constants';
import { useRemotionPlayerCurrentTime } from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerCurrentTime';
import { useRemotionPlayerSeek } from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerSeek';
import { getCompositeSegment } from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/utils';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { getPlayerConfigIntro } from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/utils/playerConfigGetters';

const CHAPTER_TIME_BUFFER = 0.1;

const NextChapter = () => {
  const transcriptStore = useTranscriptContext();
  const { clipData } = useClipsContext();
  const chapters = useMemo(() => transcriptStore.chapterData, [transcriptStore.chapterData]);
  // !! TODO Hitesh change this logic to get active current time from remotion player without using useCurrentTime hook
  const { currentTime } = useRemotionPlayerCurrentTime();
  const { seekTo } = useRemotionPlayerSeek();
  const intro = getPlayerConfigIntro(clipData.asset_metadata.player_config);

  const compositeSegment = getCompositeSegment(clipData?.asset_metadata?.player_config);

  const clickHandler = useCallback(() => {
    const introDuration = intro ? (intro.toFrame - intro.fromFrame) / FPS_24 : 0;
    const segmentCurrentTime = currentTime - introDuration;
    if (!chapters) return;
    const currentChapterIndex = chapters.findIndex((chapter, index) => {
      return (
        chapter.start_time - CHAPTER_TIME_BUFFER <= segmentCurrentTime &&
        chapters[index + 1]?.start_time - CHAPTER_TIME_BUFFER > segmentCurrentTime
      );
    });
    const nextChapter = chapters[currentChapterIndex + 1];

    if (nextChapter) {
      const nextChapterStartTime = nextChapter.start_time;
      const nextChapterEndTime = nextChapterStartTime + introDuration;
      seekTo(nextChapterEndTime);
    } else {
      const segmentDuration = (compositeSegment.maxBounds.toFrame - compositeSegment.maxBounds.fromFrame) / FPS_24;

      seekTo(segmentDuration + introDuration);
    }
  }, [chapters, compositeSegment.maxBounds.fromFrame, compositeSegment.maxBounds.toFrame, currentTime, intro, seekTo]);

  return (
    <PlayerTimelineButton
      tooltipTitle="Next Chapter"
      buttonId="next-chapter-button"
      onClick={clickHandler}
      iconName="IconPlayerSkipForward"
    />
  );
};

export default memo(NextChapter);
